import { Teacher } from '../types/teacher'

// Fictitious teachers. Each course of the "Corsi" section is assigned only to
// teachers enabled for its product code (Corsi erogabili).
export const teachers: Teacher[] = [
  {
    id: 't-01',
    firstName: 'Marco',
    lastName: 'Bianchi',
    fiscalCode: 'BNCMRC75A01A390K',
    email: 'marco.bianchi@docenti.it',
    phone: '333 1234567',
    zones: 'Arezzo, Siena',
    limitedAvailability: 'Solo la mattina, tranne il mercoledì',
    productCodes: ['FOR-FGL', 'FOR-FSB', 'FOR-FSM', 'FOR-FSA', 'FOR-PRE'],
    hourlyRate: 45,
    agreements: 'Tariffa forfettaria per corsi oltre 16 ore',
    privateEquipment: ['Videoproiettore', 'Notebook'],
    expenseReimbursement: 'Rimborso chilometrico oltre 30 km dalla sede',
    billingMethod: 'Fattura',
    documents: {
      cv: { fileName: 'CV_Marco_Bianchi.pdf', uploadedAt: '2026-03-12T10:24:00' },
      identity: { fileName: 'CI_Bianchi.pdf', uploadedAt: '2026-03-12T10:26:00' },
    },
  },
  {
    id: 't-02',
    firstName: 'Laura',
    lastName: 'Conti',
    fiscalCode: 'CNTLRA82C45D612Z',
    email: 'laura.conti@docenti.it',
    phone: '347 9876543',
    zones: 'Firenze, Prato',
    limitedAvailability: 'Disponibile solo il martedì e il giovedì',
    productCodes: ['FOR-PSB', 'FOR-AI2'],
    hourlyRate: 50,
    agreements: 'Materiale didattico incluso nella tariffa',
    privateEquipment: ['Manichino RCP', 'Estintori da addestramento'],
    expenseReimbursement: 'Nessun rimborso previsto',
    billingMethod: "Ritenuta d'acconto",
    documents: {
      cv: { fileName: 'CV_Laura_Conti.pdf', uploadedAt: '2026-01-20T15:02:00' },
      certifications: { fileName: 'Abilitazione_118.pdf', uploadedAt: '2026-01-20T15:05:00' },
      identity: { fileName: 'CI_Conti.pdf', uploadedAt: '2026-01-20T15:07:00' },
    },
  },
  {
    id: 't-03',
    firstName: 'Giorgio',
    lastName: 'Neri',
    fiscalCode: 'NREGRG70M10G478P',
    email: 'giorgio.neri@docenti.it',
    phone: '340 5551234',
    zones: 'Perugia, Arezzo',
    limitedAvailability: 'Non disponibile nel mese di agosto',
    productCodes: ['FOR-CAR', 'FOR-PLE'],
    hourlyRate: 55,
    agreements: 'Prova pratica fatturata a parte',
    privateEquipment: ['Kit DPI dimostrativi'],
    expenseReimbursement: 'Rimborso pasti per giornate intere',
    billingMethod: 'Fattura',
    documents: {
      cv: { fileName: 'CV_Giorgio_Neri.pdf', uploadedAt: '2025-11-04T09:40:00' },
    },
  },
  {
    id: 't-04',
    firstName: 'Sara',
    lastName: 'Galli',
    fiscalCode: 'GLLSRA85T52H501W',
    email: 'sara.galli@docenti.it',
    phone: '328 4447788',
    zones: 'Siena, Firenze, Roma',
    limitedAvailability: 'Solo il pomeriggio',
    productCodes: ['FOR-RLS', 'FOR-ARL', 'FOR-DIR', 'FOR-RDL'],
    hourlyRate: 60,
    agreements: 'Minimo 4 ore per incarico',
    privateEquipment: ['Notebook'],
    expenseReimbursement: 'Rimborso a piè di lista',
    billingMethod: 'Fattura',
    documents: {},
  },
  {
    id: 't-05',
    firstName: 'Paolo',
    lastName: 'Ferri',
    fiscalCode: 'FRRPLA78B15E715Q',
    email: 'paolo.ferri@docenti.it',
    phone: '339 2223344',
    zones: 'Arezzo',
    limitedAvailability: 'Tutti i giorni, tranne il venerdì',
    productCodes: ['FOR-HAC', 'FOR-FGL'],
    hourlyRate: 40,
    agreements: 'Registrazioni on-demand compensate a forfait',
    privateEquipment: ['Videoproiettore'],
    expenseReimbursement: 'Nessun rimborso previsto',
    billingMethod: "Ritenuta d'acconto",
    documents: {
      cv: { fileName: 'CV_Paolo_Ferri.pdf', uploadedAt: '2026-05-08T11:15:00' },
    },
  },
  {
    id: 't-06',
    firstName: 'Elena',
    lastName: 'Moretti',
    fiscalCode: 'MRTLNE80D48D612F',
    email: 'elena.moretti@docenti.it',
    phone: '345 6612098',
    zones: 'Firenze, Pistoia, Prato',
    limitedAvailability: 'Solo il sabato mattina e il lunedì',
    productCodes: ['FOR-AI2', 'FOR-PSB', 'FOR-FSA'],
    hourlyRate: 52,
    agreements: 'Esercitazione pratica antincendio compresa nella tariffa',
    privateEquipment: ['Estintori da addestramento', 'Vasca per fuochi controllati'],
    expenseReimbursement: 'Rimborso chilometrico oltre 50 km dalla sede',
    billingMethod: 'Fattura',
    documents: {
      cv: { fileName: 'CV_Elena_Moretti.pdf', uploadedAt: '2026-02-03T09:12:00' },
      certifications: { fileName: 'Attestato_VVF_Moretti.pdf', uploadedAt: '2026-02-03T09:15:00' },
      identity: { fileName: 'CI_Moretti.pdf', uploadedAt: '2026-02-03T09:16:00' },
    },
  },
  {
    id: 't-07',
    firstName: 'Andrea',
    lastName: 'Rossetti',
    fiscalCode: 'RSSNDR72H12G478C',
    email: 'andrea.rossetti@docenti.it',
    phone: '335 7781204',
    zones: 'Perugia, Terni, Arezzo',
    limitedAvailability: 'Disponibile dal lunedì al giovedì',
    productCodes: ['FOR-CAR', 'FOR-PLE', 'FOR-FSA'],
    hourlyRate: 58,
    agreements: 'Uso dei mezzi del cliente per la prova pratica',
    privateEquipment: ['Carrello elevatore', 'Kit DPI dimostrativi'],
    expenseReimbursement: 'Rimborso pasti e pernottamento oltre 100 km',
    billingMethod: 'Fattura',
    documents: {
      cv: { fileName: 'CV_Andrea_Rossetti.pdf', uploadedAt: '2025-12-15T16:40:00' },
      identity: { fileName: 'CI_Rossetti.pdf', uploadedAt: '2025-12-15T16:42:00' },
    },
  },
  {
    id: 't-08',
    firstName: 'Chiara',
    lastName: 'Lombardi',
    fiscalCode: 'LMBCHR88S61A390N',
    email: 'chiara.lombardi@docenti.it',
    phone: '349 3309871',
    zones: 'Arezzo, Siena, Grosseto',
    limitedAvailability: 'Solo il pomeriggio, tranne il venerdì',
    productCodes: ['FOR-HAC'],
    hourlyRate: 42,
    agreements: 'Lezioni registrate per on-demand pagate a modulo',
    privateEquipment: ['Notebook', 'Kit tamponi dimostrativi'],
    expenseReimbursement: 'Nessun rimborso previsto',
    billingMethod: "Ritenuta d'acconto",
    documents: {
      cv: { fileName: 'CV_Chiara_Lombardi.pdf', uploadedAt: '2026-04-22T10:05:00' },
    },
  },
  {
    id: 't-09',
    firstName: 'Roberto',
    lastName: 'Valentini',
    fiscalCode: 'VLNRRT66E03H501T',
    email: 'roberto.valentini@docenti.it',
    phone: '338 9012345',
    zones: 'Roma, Siena',
    limitedAvailability: 'Non disponibile il mercoledì',
    productCodes: ['FOR-DIR', 'FOR-RDL', 'FOR-PRE', 'FOR-RLS'],
    hourlyRate: 65,
    agreements: 'Minimo 8 ore per incarico; materiale didattico fornito dal docente',
    privateEquipment: ['Videoproiettore', 'Lavagna a fogli mobili'],
    expenseReimbursement: 'Rimborso a piè di lista',
    billingMethod: 'Fattura',
    documents: {
      cv: { fileName: 'CV_Roberto_Valentini.pdf', uploadedAt: '2026-01-09T12:30:00' },
      certifications: { fileName: 'Qualifica_formatore_sicurezza.pdf', uploadedAt: '2026-01-09T12:33:00' },
      identity: { fileName: 'CI_Valentini.pdf', uploadedAt: '2026-01-09T12:34:00' },
    },
  },
  {
    id: 't-10',
    firstName: 'Francesca',
    lastName: 'Ricci',
    fiscalCode: 'RCCFNC90B50D612S',
    email: 'francesca.ricci@docenti.it',
    phone: '366 4402217',
    zones: 'Firenze, Arezzo',
    limitedAvailability: 'Solo la mattina',
    productCodes: ['FOR-FGL', 'FOR-FSB', 'FOR-FSM', 'FOR-ARL'],
    hourlyRate: 44,
    agreements: 'Disponibile anche per docenza in FAD',
    privateEquipment: ['Notebook'],
    expenseReimbursement: 'Rimborso chilometrico oltre 30 km dalla sede',
    billingMethod: "Ritenuta d'acconto",
    documents: {
      identity: { fileName: 'CI_Ricci.pdf', uploadedAt: '2026-06-02T08:50:00' },
    },
  },
]
